/*
    This function is a combination of these two Stackoverflow posts:
    https://stackoverflow.com/questions/50195475/detect-if-device-is-tablet/53518181
    https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser/11381730#11381730
*/

import { useEffect, useState } from 'react';
import { isSafari } from 'scribe-web-shared/functions';

export const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

export const isMobile = (userAgent = navigator.userAgent || navigator.vendor) => {
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
    userAgent
  );
};

export const isTablet = (userAgent = navigator.userAgent || navigator.vendor) => {
  return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/i.test(
    userAgent.toLowerCase()
  );
};

export const isMobileOrTablet = (userAgent = navigator.userAgent || navigator.vendor) => {
  return isMobile(userAgent) || isTablet(userAgent) || (isSafari && isTouchDevice());
};

const isMobileSize = () => {
  return window?.innerWidth <= 768;
};

export const useIsMobileSize = () => {
  const [isMOT, setIsMOT] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsMOT(isMobileSize());
      window.addEventListener('resize', () => {
        setIsMOT(isMobileSize());
      });
    }
  }, []);

  return isMOT;
};

const isSmallMobileSize = () => {
  return window?.innerWidth <= 640;
};

export const useIsSmallMobileSize = () => {
  const [isSmallMobile, setIsSmallMobile] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsSmallMobile(isSmallMobileSize());
      window.addEventListener('resize', () => {
        setIsSmallMobile(isSmallMobileSize());
      });
    }
  }, []);

  return isSmallMobile;
};

export const getMobileOS = () => {
  const ua = global.navigator?.userAgent || '';

  if (/android/i.test(ua)) {
    return 'android';
  }
  if (/iPad|iPhone|iPod/.test(ua) || (global.navigator?.platform === 'MacIntel' && global.navigator?.maxTouchPoints > 1)) {
    return 'ios';
  }
  return 'other';
};

export const isDisallowedUserAgent = () => {
  const disallowedUserAgentPatterns = [
    /(wv)/, // Android WebView
    /(iphone|ipad|ipod).*applewebkit(?!.*safari)/ // iOS WebView (UIWebView/WKWebView)
  ];

  return disallowedUserAgentPatterns.some((pattern) => pattern.test(navigator?.userAgent));
};
